export const noIFSCList = {
  '606': 'A.P. Mahesh Co-operative Urban Bank',
  '99': 'Abhyudaya Co-operative Bank',
  '334': 'Adarsh Co-operative Bank',
  '335': 'Ahmedabad District Co-operative Bank',
  '637': 'Ahmednagar Merchants Co-operative Bank',
  '336': 'Ahmednagar Shahar Sahakari Bank Maryadit',
  '585': 'Airtel Payments Bank',
  '337': 'Akhand Anand Co.op Bank',
  '338': 'Akola Janata Commercial Co-operative Bank',
  '266': 'Alavi Co-operative Bank',
  '37': 'Allahabad Bank',
  '187': 'Almora Urban Co-operative Bank',
  '183': 'Amarnath Co-operative Bank',
  '250': 'Ambarnath Jai-hind Co-operative Bank',
  '31': 'Andhra Bank',
  '247': 'Andhra Pradesh Grameena Vikas Bank',
  '240': 'Andhra Pragathi Grameena Bank',
  '557': 'Annasaheb Magar Sahakari Bank',
  '145': 'Apna Sahakari Bank',
  '544': 'Arunachal Pradesh Rural Bank',
  '541': 'Arvind Sahakari Bank',
  '339': 'Ashoknagar Co-operative Bank',
  '211': 'Assam Gramin Vikash Bank',
  '192': 'Associate Co-operative Bank',
  '159': 'AU Small Finance Bank',
  '4': 'Axis Bank',
  '340': 'Balasinor Nagarik Sahakari Bank',
  '738': 'Banda Urban Co-operative Bank',
  '140': 'Bandhan Bank',
  '341': 'Bangalore City Co-operative Bank',
  '342': 'Bangalore  Bangalore Rural&ramanagara Dccb',
  '533': 'Bangiya Gramin Vikash Bank',
  '17': 'Bank of Baroda',
  '16': 'Bank of India',
  '30': 'Bank of Maharashtra',
  '262': 'Baroda Gujarat Gramin Bank',
  '134': 'Baroda Rajasthan Kshetriya Gramin Bank',
  '260': 'Baroda Uttar Pradesh Gramin Bank',
  '208': 'Bassein Catholic Co-operative Bank',
  '506': 'Bhadradri Co-operative Urban Bank',
  '307': 'Bharat Co-operative Bank',
  '323': 'Bharati Sahakari Bank',
  '753': 'Bhilwara Urban Co-operative Bank',
  '626': 'Bhind Nagrik Sahakari Bank Mydt',
  '513': 'BNP Paribas Bank',
  '116': 'Bombay Mercantile Co-operative Bank',
  '739': 'Chhattisgarh Rajya Sahakari Bank Mydt',
  '12': 'Canara Bank',
  '347': 'Capital Small Finance Bank',
  '348': 'Catholic Syrian Bank',
  '42': 'Central Bank of India',
  '758': 'Chennai Central Co-operative Bank',
  '523': 'Chhattisgarh Rajya Gramin Bank',
  '642': 'Chittorgarh Urban Co-operative Bank',
  '6': 'CITI Bank',
  '190': 'Citizen Credit Co-operative Bank',
  '287': 'Citizens Co-operative Bank',
  '49': 'City Union Bank',
  '679': 'Contai Co-operative Bank',
  '21': 'Corporation Bank',
  '270': 'Daivadnya Sahakara Bank Niyamit',
  '529': 'Dakshin Bihar Gramin Bank',
  '693': 'Dapoli Urban Co-operative Bank',
  '189': 'Dattatraya Maharaj Kalambe Jaoli Sahakari Bank',
  '354': 'Development Bank of Singapore',
  '50': 'DCB Bank',
  '633': 'Deendayal Nagari Sahakari Bank',
  '356': 'Dehradun District Co-operative Bank',
  '109': 'Delhi Nagrik Sehkari Bank',
  '51': 'Dena Bank',
  '357': 'Deogiri Nagari Sahakari Bank Aurangabad',
  '293': 'Deutsche Bank',
  '359': 'Devika Urban Co-operative Bank',
  '584': 'Dhanera Mercantile Co-operative Bank',
  '52': 'Dhanlaxmi Bank',
  '95': 'Dombivli Nagari Sahakari Bank',
  '304': 'Ellaquai Dehati Bank',
  '174': 'Equitas Small Finance Bank',
  '561': 'ESAF Small Finance Bank',
  '361': 'Etawah District Co-operative Bank Etwah',
  '32': 'Federal Bank',
  '596': 'Fincare Small Finance Bank ',
  '521': 'Fingrowth Co-operative Bank',
  '73': 'Gopinath Patil Parsik Janata Sahakari Bank',
  '184': 'Gramin Bank of Aryavart',
  '564': 'Mahanagar Co-operative Bank',
  '365': 'Guardian Souharda Sahakari Bank Niyamita',
  '616': 'Gujarat Ambuja Co-operative Bank',
  '605': 'Gujarat Mercantile Co-operative Bank',
  '689': 'Gulshan Mercantile Urban Co-operative Bank',
  '632': 'Haveli Sahakari Bank',
  '9': 'HDFC Bank',
  '126': 'Himachal Pradesh Gramin Bank',
  '514': 'Himatnagar Nagarik Sahakari Bank',
  '8': 'Hongkong & Shanghai Banking Corporation',
  '7': 'ICICI Bank',
  '15': 'IDBI',
  '531': 'IDFC FIRST Bank',
  '749': 'Imperial Urban Co-operative Bank',
  '53': 'Indian Bank',
  '18': 'Indian Overseas Bank',
  '598': 'India Post Payments Bank',
  '748': 'Indore Paraspar Sahakari Bank',
  '593': 'Indraprastha Sehkari Bank',
  '520': 'Indrayani Co-operative Bank',
  '10': 'Indusind Bank',
  '368': 'Integral Urban Co-operative Bank',
  '182': 'Jain Co-operative Bank',
  '105': 'Jalgaon Janata Bank',
  '369': 'Jalna Merchants Co-operative Bank',
  '518': 'Jalore Nagrik Sahakari Bank',
  '70': 'Jamia Co-operative Bank',
  '196': 'Janakalyan Sahakari Bank',
  '509': 'Jana Small Finance Bank',
  '36': 'Jammu and Kashmir Bank',
  '239': 'J&K Grameen Bank',
  '302': 'Jharkhand Rajya Gramin Bank',
  '241': 'Jharneshwar Nagrik Sahakari Bank Maryadit',
  '530': 'Jijamata Mahila Sahakari Bank',
  '685': 'Jivan Commercial Co-operative Bank',
  '507': 'Jodhpur Nagrik Sahakari Bank',
  '374': 'Kaira District Central Co-operative Bank',
  '242': 'Kallappanna Awade Ichalkaranji Janata Sahakari Bank',
  '74': 'Kankaria Mainagar Nagrik Sahakari Bank',
  '14': 'Karnataka Bank',
  '572': 'Karnataka Gramin Bank',
  '259': 'Karnataka Vikas Grameena Bank',
  '215': 'Kashipur Urban Co-operative Bank',
  '313': 'Kashmir Mercantile Co-operative Bank',
  '378': 'Kavita Urban Co-operative Bank',
  '291': 'Kerala Gramin Bank',
  '696': 'Kerala State Co-operative Bank',
  '84': 'Keshav Sehkari Bank',
  '687': 'Khalilabad Nagar d Bank',
  '379': 'Khamgaon Urban Co-operative Bank',
  '204': 'Kokan Mercantile Co-operative Bank',
  '3': 'Kotak Mahindra Bank',
  '380': 'Kota Nagrik d Bank Kota',
  '381': 'Koteshwara Sahakari Bank Niyamitha',
  '611': 'Kozhikode District Co-operative Bank',
  '253': 'Kurmanchal Nagar Sahakari Bank',
  '608': 'Lakhimpur Urban Co-operative Bank',
  '200': 'Liluah Co-operative Bank',
  '383': 'Lokmangal Co-operative Bank Solapur',
  '384': 'Lokvikas Nagari Sahakari Bank Aurangabad',
  '636': 'Lonavala Sahakari Bank',
  '297': 'Madhyanchal Gramin Bank',
  '218': 'Maharashtra Gramin Bank',
  '137': 'Maharashtra State Co-operative Bank',
  '540': 'Mahesh Sahakari Bank Pune',
  '732': 'Mahesh Urban Co-operative Bank',
  '212': 'Makarpura Industrial Estate Co-operative Bank',
  '763': 'Malviya Urban Co-operative Bank',
  '385': 'Mandya District Co-operative Central Bank',
  '386': 'Manorama Co-operative Bank Solapur',
  '387': 'Mansarovar Urban Co-operative Bank',
  '388': 'Manvi Pattana Souharda Sahakari Bank Ni',
  '700': 'Zila Sahakari Bank Mathura',
  '80': 'Model Co-operative Bank',
  '115': 'Mumbai District Central Co-operative Bank',
  '206': 'Muzaffarnagar District Co-operative Bank',
  '129': 'Nagpur Nagarik Sahakari Bank',
  '390': 'Nainital Bank',
  '391': 'Nainital District Co-operative Bank',
  '392': 'Narmada Jhabua Gramin Bank',
  '223': 'Nashik District Girna Sahakari Bank',
  '552': 'Nashik Zila Mahila Vikas Sahakari Bank',
  '713': 'National Urban Co-operative Bank',
  '305': 'Navabharat Co-operative Urban Bank',
  '149': 'Navanagara Urban Co-operative Bank',
  '86': 'Navi Mumbai Co-operative Bank',
  '393': 'Navsarjan Industrial Co-operative Bank',
  '127': 'New India Co-operative Bank',
  '121': 'Nidhi Co-operative Bank',
  '282': 'Nirmal Urban Co-operative Bank Nagpur',
  '71': 'NKGSB Co-operative Bank',
  '601': 'Noida Commercial Co-operative Bak',
  '526': 'North East Small Finance Bank',
  '55': 'Nutan Nagarik Sahakari Bank',
  '510': 'Odisha Gramya Bank',
  '20': 'Oriental Bank of Commerce',
  '612': 'Osmanabad Janata Sahakari Bank',
  '571': 'Pali Urban Co-operative Bank',
  '329': 'Pallavan Grama Bank',
  '692': 'Shree Panchganga Nagari Sahakari Bank',
  '395': 'Panipat Urban Co-operative Bank',
  '527': 'Paschim Banga Gramin Bank',
  '112': 'Pavana Sahakari Bank',
  '573': 'Paytm Payments Bank',
  '502': 'Pimpri Chinchwad Sahakari Bank Maryadit, pimpri',
  '245': 'Pochampally Co-operative Urban Bank',
  '301': 'Poornawadi Nagrik Sahakari Bank',
  '177': 'Pragathi Krishna Gramin Bank',
  '136': 'Pragati Sahakari Bank',
  '556': 'Pravara Sahakari Bank',
  '562': 'Prerana Co-operative Bank',
  '185': 'Prime Co-operative Bank',
  '639': 'Priyadarshani Nagari Sahakari Bank Jalna.',
  '555': 'Pune Cantonment Sahakari Bank',
  '643': 'Pune District Central Co-operative Bank',
  '711': "Pune Merchant's Co-operative Bank",
  '255': "Pune People's Co-operative Bank",
  '107': 'Pune Urban Co-operative Bank',
  '41': 'Punjab & Sind Bank',
  '397': 'Punjab Gramin Bank',
  '19': 'Punjab National Bank',
  '220': 'Purvanchal Gramin Bank',
  '398': 'Pusad Urban Co-operative Bank',
  '399': 'Raichur District Central Co-operative Bank',
  '769': 'Rajapur Urban Co-operative Bank',
  '175': 'Rajarambapu Sahakari Bank',
  '539': 'Rajarshi Shahu Sahakari Bank',
  '328': 'Rajasthan Marudhara Gramin Bank',
  '263': 'Rajdhani Nagar Sahakari Bank',
  '151': 'Rajgurunagar Sahakari Bank',
  '125': 'Rajkot Nagarik Sahakari Bank',
  '631': 'Rajlaxmi Urban Co-operative Bank',
  '318': 'Ramgarhia Co-operative Bank',
  '326': 'Rampur Zila Sahakari Bank',
  '648': 'Ratnagiri District Central Co-operative Bank',
  '309': 'RBL Bank',
  '402': 'Sadhana Sahakari Bank',
  '545': 'Saibaba Nagari Sahakari Bank',
  '271': 'Samarth Sahakari Bank',
  '759': 'Samata Co-operative Development Bank',
  '525': 'Sampada Sahakari Bank',
  '404': 'Samruddhi Co-operative Bank',
  '87': 'Samata Sahakari Bank',
  '645': 'Sangli Sahakari Bank',
  '279': 'Sangli Urban Co-operative Bank',
  '501': 'Sant Sopankaka Sahakari Bank',
  '108': 'Saraspur Nagarik Co-operative Bank',
  '89': 'Saraswat Co-operative Bank',
  '650': 'Sardar Vallabhbhai Sahakari Bank',
  '406': 'Sarva Haryana Gramin Bank',
  '542': 'Sarvodaya Commerical Co-operative Bank',
  '332': 'Saurashtra Gramin Bank',
  '630': 'Sawai Madhopur Kendriya Sahakari Bank',
  '604': 'SBM Bank',
  '613': "Sardar Bhiladwala Pardi People's Co-operative Bank",
  '408': 'Shankar Nagari Sahakari Bank',
  '201': 'Sharad Sahakari Bank',
  '135': 'Shikshak Sahakari Bank',
  '750': 'Shivalik Small Finance Bank',
  '310': 'Shree Bharat Co-operative Bank',
  '286': 'Shree Dharati Co-operative Bank',
  '500': 'Shree Kadi Nagarik Sahakari Bank',
  '640': 'Shree Laxmi Co-operative Bank',
  '768': 'Shree Mahalaxmi Mercantile Co-operative Bank',
  '233': 'Shree Mahalaxmi Urban Co-operative Credit Bank',
  '412': 'Shree Mahavir Sahakari Bank',
  '289': 'Shree Mahesh Co-operative Bank Nashik',
  '267': 'Shree Samarth Sahakari Bank Nashik',
  '413': 'Shree Vardhaman Sahakari Bank',
  '747': 'Shree Warana Sahakari Bank',
  '102': 'Shri Arihant Co-operative Bank',
  '415': 'Shri Chhatrapati Rajashri Shahu Urban Co-operative Bank',
  '416': 'Shri D T Patil Co-operative Bank',
  '268': 'Shri Ganesh Sahakari Bank',
  '296': 'Shri Kanyaka Nagari Sahakari Bank',
  '420': 'Shrikrishna Co-operative Bank',
  '691': 'Shri Mahavir Urban Co-operative Bank',
  '504': 'Shri Rajkot District Co-operative Bank',
  '421': 'Shriram Urban Co-operative Bank',
  '228': 'Sikar Kendriya Sahakari Bank',
  '722': 'Sikkim State Co-operative Bank',
  '716': 'Smriti Nagrik Sahakari Bank',
  '199': 'Solapur Janata Sahakari Bank',
  '422': 'South Indian Bank',
  '705': 'Sree Charan Souhardha Co-operative Bank',
  '138': 'Shree Thyagaraja Co-operative Bank',
  '423': 'Sri Sudha Co-operative Bank',
  '224': 'Sri Vasavamba Co-operative Bank',
  '2': 'Standard Chartered Bank',
  '1': 'State Bank of India',
  '330': 'Sterling Urban Co-operative Bank',
  '173': 'Suco Souharda Sahakari Bank',
  '499': 'Sulaimani Co-operative Bank',
  '622': 'Sundarlal Sawaji Urban Co-operative Bank',
  '217': 'Surat National Co-operative Bank',
  '512': 'Suryoday Small Finance Bank',
  '122': 'Suvarnayug Sahakari Bank',
  '205': 'SVC Co-operative Bank',
  '40': 'Syndicate Bank',
  '94': 'Tamilnad Mercantile Bank',
  '743': 'Tamluk-ghatal Central Co-operative Bank',
  '229': 'Telangana State Co-operative Apex Bank',
  '272': 'Telangana Grameena Bank',
  '278': 'Thane Bharat Sahakari Bank',
  '277': 'Abhinav Sahakari Bank',
  '706': 'Ajara Urban Co-operative Bank',
  '273': 'Akola District Central Co-operative Bank',
  '144': 'Akola Urban Co-operative Bank',
  '429': 'Amritsar Central Co-operative Bank',
  '317': 'Anand Mercantile Co-operative Bank',
  '727': 'Assam Co-operative Apex Bank',
  '430': 'Baghat Urban Co-operative Bank',
  '574': 'Banaskantha District Central Co-operative Bank',
  '517': 'Banaskantha Mercantile Co-operative Bank',
  '535': 'Bapunagar Mahila Co-operative Bank',
  '431': 'Baramati Sahakari Bank',
  '684': 'Baroda Central Co-operative Bank',
  '432': 'Baroda City Co-operative Bank',
  '725': 'Bhagyalakshmi Mahila Sahakari Bank',
  '155': 'Bhagyodaya Co-operative Bank',
  '434': 'Bhandara Urban Co-operative Bank',
  '649': 'Bharuch District Central Co-operative Bank Bharuc',
  '435': 'Bhatkal Urban Co-operative Bank',
  '621': 'Bhiwani Central Co-operative Bank Bhiwani',
  '567': 'Bhuj Mercentile Co-operative Bank',
  '314': 'Business Co-operative Bank',
  '764': 'Chandigarh State Co-operative Bank',
  '742': 'Chandrapur District Central Co-operative Bank',
  '566': 'Chembur Nagarik Sahakari Bank',
  '628': 'Chikhli Urban Co-operative Bank',
  '676': 'Chiplun Urban Co-operative Bank',
  '715': 'Chitnavispura Sahakari Bank',
  '547': 'Commercial Co-operative Bank',
  '581': 'Co-operative Bank of Mehsana',
  '254': 'Co-operative Bank of Rajkot',
  '98': 'Cosmos Co-operative Bank',
  '537': 'Dahod Mercantile Co-operative Bank',
  '686': 'Deccan Co-operative Urban Bank',
  '603': 'Deccan Merchants Co-operative Bank',
  '591': 'Delhi State Co-operative Bank',
  '594': 'Gadchiroli District Central Co-operative Bank',
  '721': "Gandevi People's Co-operative Bank",
  '680': 'Gandhidham Co-operative Bank',
  '761': 'Gandhidham Mercantile Co-operative Bank',
  '214': 'Ganga Mercantile Urban Co-operative Bank',
  '237': 'Gayatri Co-operative Urban Bank',
  '620': 'Goa State Co-operative Bank',
  '712': 'Goa Urban Co-operative Bank',
  '511': 'Godhra Urban Co-operative Bank',
  '505': 'Gondia District Central Co-operative Bank Gondia',
  '440': "Grain Merchants' Co-operative Bank",
  '120': 'Greater Bombay Co-operative Bank',
  '441': 'Gujarat State Co-operative Bank',
  '442': 'Haryana State Co-operative Apex Bank',
  '202': 'HASTI Co-operative Bank',
  '751': 'Hoshiarpur Central Co-operative Bank',
  '133': 'Himachal Pradesh State Co-operative Bank',
  '444': 'Hubli Urban Co-operative Bank',
  '236': 'Hyderabad District Co-operative Bank',
  '312': 'Jaipur Central Co-operative Bank',
  '446': 'Jalandhar Central Co-operative Bank',
  '256': 'Jalgaon Peoples Co-operative Bank',
  '143': 'Janata Co-operative Bank',
  '757': 'Jind Central Co-operative Bank',
  '450': 'Junagadh Commercial Co-operative Bank',
  '576': 'Kalol Nagarik Sahakari Bank',
  '128': 'Kalupur Commercial Co-operative Bank',
  '101': 'Kalyan Janata Sahakari Bank',
  '607': 'Kanara District Central Co-operative Bank',
  '451': 'Kangra Central Co-operative Bank',
  '222': 'Kangra Co-operative Bank',
  '232': 'Karad Urban Co-operative Bank',
  '252': 'Karimnagar District Co-operative Central Bank',
  '634': 'Karnal Central Co-operative Bank',
  '248': 'Karnataka State Co-operative Apex Bank',
  '453': 'Karnavati Co-operative Bank',
  '13': 'Karur Vysya Bank',
  '690': 'Kasaragod District Co-operative Bank',
  '752': 'Kodinar Nagrik Sahakari Bank',
  '619': 'Kodinar Taluka Co-operative Banking Union',
  '707': 'Kolhapur Urban Co-operative Bank',
  '320': 'Kopargaon Peoples Co-operative Bank',
  '553': 'Kukarwada Nagarik Sahakari Bank',
  '647': 'Latur Urban Co-operative Bank Latur',
  '454': 'Laxmi Co-operative Bank Solapur',
  '160': 'Mahaveer Co-operative Bank',
  '88': 'The Malad Sahakari Bank',
  '729': 'Malappuram District Co-operative Bank',
  '456': 'Malkapur Urban Co-operative Bank',
  '457': 'Mangalore Co-operative Town Bank',
  '331': 'Mansa Nagarik Sahakari Bank',
  '731': 'Mehsana Nagarik Sahakari Bank',
  '275': 'Mehsana Urban Co-operative Bank',
  '147': 'Modasa Nagarik Sahakari Bank',
  '459': 'Moga Central Co-operative Bank',
  '460': 'Muslim Co-operative Bank',
  '230': 'Nadiad Peoples Co-operative Bank',
  '179': 'Nagaur Central Co-operative Bank',
  '461': 'Nanded Merchants Co-operative Bank Nanded',
  '610': 'Nandura Urban Co-operative Bank Nandura',
  '463': 'Naroda Nagrik Co-operative Bank',
  '123': 'Nasik Merchants Co-operative Bank',
  '114': 'National Co-operative Bank',
  '193': 'Nav Jeevan Co-operative Bank',
  '464': 'Navnirman Co-operative Bank',
  '592': 'Nawanagar Co-operative Bank',
  '269': 'New Urban Co-operative Bank Rampur',
  '466': "Ojhar Merchant's Co-operative Bank",
  '746': 'Panchmahal District Co-operative Bank',
  '251': 'Panchsheel Mercantile Co-operative Bank',
  '548': 'Payangadi Urban Co-operative Bank',
  '226': 'Pimpalgaon Merchants Co-operative Bank',
  '231': 'Pratap Co-operative Bank',
  '737': 'Raigad District Central Co-operative Bank',
  '261': 'Raipur Urban Mercantile Co-operative Bank',
  '148': 'Rajajinagar Co-operative Bank',
  '469': 'Rajasthan State Co-operative Bank',
  '694': 'Rajkot Commercial Co-operative Bank',
  '82': 'Rander Peoples Co-operative Bank',
  '625': 'Ranuj Nagrik Sahakari Bank',
  '549': 'Rohtak Central Co-operative Bank',
  '579': 'Sabarkantha District Central Co-operative Bank',
  '264': 'Sahebrao Deshmukh Co-operative Bank',
  '528': 'Sangamner Merchants Co-operative Bank',
  '623': 'Sangli District Central Co-operative Bank',
  '719': 'Sardargunj Mercantile Co-operative Bank Patan',
  '92': 'Sarvodaya Sahakari Bank',
  '207': 'Satara Sahakari Bank',
  '181': 'Saurashtra Co-operative Bank',
  '543': 'Shahada Peoples Co-operative Bank',
  '169': 'Shirpur Peoples Co-operative Bank',
  '472': 'Solapur Social Urban Co-operative Bank',
  '168': 'South Canara District Central Co-operative Bank',
  '473': 'Sri Kannikaparameswari Co-operative Bank',
  '677': "Sultan's Bathery Co-operative Urban Bank",
  '66': 'Surat District Co-operative Bank',
  '166': 'Surat Mercantile Co-operative Bank',
  '235': "Surat People's Co-operative Bank",
  '67': 'Sutex Co-operative Bank',
  '477': 'Tarn Taran Central Co-operative Bank',
  '478': 'Textile Co-operative Bank of Surat',
  '651': 'Thane District Central Co-operative Bank',
  '170': 'Town Co-operative Bank Hoskote',
  '577': 'Udaipur Central Co-operative Bank',
  '536': 'Udaipur Mahila Samridhi Urban Co-operative Bank',
  '586': 'Udaipur Mahila Urban Co-operative Bank',
  '479': 'Udaipur Urban Co-operative Bank',
  '480': 'Umreth Urban Co-operative Bank',
  '563': 'Una Peoples Co-operative Bank',
  '481': 'Union Co-operative Bank',
  '538': 'Vaidyanath Urban Co-operative Bank',
  '767': 'Vaijapur Merchants Co-operative Bank',
  '258': 'Vaish Co-operative Adarsh Bank',
  '225': 'Vallabh Vidyanagar Commercial Bank',
  '141': 'Varachha Co-operative Bank',
  '124': 'Vardhaman Co-operative Bank',
  '578': 'Veraval Mercantile Co-operative Bank',
  '172': 'Veraval Peoples Co-operative Bank',
  '68': 'The Vijay Co-operative Bank',
  '72': 'Vishweshwar Sahakari Bank',
  '766': 'Vita Merchants Co-operative Bank',
  '482': 'Waghodia Urban Co-operative Bank',
  '641': 'Wai Urban Co-operative Bank',
  '570': 'Washim Urban Co-operative Bank.',
  '483': 'Yavatmal Mahila Sahakari Bank',
  '551': 'Yavatmal Urban Co-operative Bank',
  '484': 'Zoroastrian Co-operative Bank',
  '485': 'Tirupati Urban Co-operative Bank',
  '249': 'TJSB Sahakari Bank',
  '723': 'Tripura Gramin Bank',
  '104': "Tumkur Grain Merchant's Co-operative Bank",
  '43': 'UCO Bank',
  '188': 'Udham Singh Nagar District Co-operative Bank',
  '327': 'Ujjivan Small Finance Bank',
  '303': 'Uma Co-operative Bank',
  '283': 'Umiya Urban Co-operative Bank',
  '39': 'Union Bank of India',
  '22': 'United Bank of India',
  '516': 'Utkal Grameen Bank',
  '216': 'Utkarsh Small Finance Bank',
  '194': 'Uttarakhand Gramin Bank',
  '298': 'Uttarakhand State Co-operative Bank',
  '688': 'Uttarbanga Kshetriya Gramin Bank',
  '324': 'Uttar Bihar Gramin Bank',
  '558': 'Uttar Pradesh Co-operative Bank',
  '221': 'Uttrakhand Co-operative Bank',
  '524': 'Vaishya Nagari Sahakari Bank',
  '186': 'Valsad District Central Co-operative Bank',
  '568': 'Vardhaman (mahila) Co-operative Urban Bank',
  '683': 'Vasai Janata Sahakari Bank',
  '203': 'Vasai Vikas Sahakari Bank',
  '617': 'Veerashaiva Sahakari Bank',
  '755': 'Vidarbha Merchants Urban Co-operative Bank',
  '492': 'Vidharbha Kokan Gramin Bank',
  '246': 'Vidya Sahakari Bank',
  '28': 'Vijaya Bank',
  '718': 'Vijay Commercial Co-operative Bank',
  '494': 'Vikas Sahakari Bank Solapur',
  '165': 'Vikas Souharda Co-operative Bank',
  '227': 'Vishwas Co-operative Bank',
  '496': 'Wardhaman Urban Co-operative Bank Nagpur',
  '569': 'Wardha Nagri Bank',
  '615': 'Wayanad District Co-operative Bank',
  '730': 'Woori Bank',
  '11': 'Yes Bank',
};

export const AccountType = '2';
